import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StoreAdminDetails } from "../../../../types/modules/admin/StoreAdmin.type";
import { fetchAddressFromCoords } from "../../../../utils/methods/fetchAddressFromCoords";
import {Edit2, Image} from "lucide-react"
import CustomModal from "../../../ui/CustomModal";
import ComissionForm from "./ComissionForm";
import { formatNumber, formatPhoneNumber, formatTime } from "../../../../utils/formatNumber";
import DateTimeText from "../../../ui/DateTimeText";
import { PermissionGate } from "../../PermissionGate";
import { PermissionsKey } from "../../../../data/permissions";

type Props = {
  store: StoreAdminDetails;
};

const StoreDetails: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const {
    subType,
    taxNumber,
    commercialRegister,
    commission,
    lat,
    lng,
    openTime,
    closeTime,
    phoneLogin,
    isOnline,
    createdAt,
    lastActive,
    taxNumberUrl,
    commercialRegisterUrl,
    lastLoginAt
  } = store;


  const [address, setAddress] = useState("");
    
    useEffect(() => {
      const getAddress = async () => {
        const result = await fetchAddressFromCoords(lat, lng);
        setAddress(result);
      };
      getAddress();
    }, [lat, lng]);

      const [isOpen, setIsOpen] = useState(false);
      const [isOpencommercialRegisterUrl,setisOpencommercialRegisterUrl] = useState(false);
      const [isOpentaxNumberUrl,setisOpentaxNumberUrl] = useState(false)
    

  return (
    <div className="border-t border-LightGrey3 pt-4">
      <h2 className="text-lg font-semibold text-Black mb-2">{t("storeDetails")}</h2>
      <div className="grid grid-cols-2 gap-4 text-sm text-muted">
        <p><span className="font-medium text-Black">{t("type")}: </span>{subType?.type?.languages?.[0]?.name || "—"}</p>
        <p><span className="font-medium text-Black">{t("subType")}: </span>{subType?.languages?.[0]?.name || "—"}</p>
        <div className="font-medium text-Black flex items-center gap-1">
          <span>{t("commission")}: </span>
          <span>{commission !== null ? `${formatNumber(commission.commissionPercent)}%` : "—"} </span>
          <PermissionGate permissions={[PermissionsKey.CommissionStore]}>
            <button onClick={()=>setIsOpen(p=>true)} className="ms-2"><Edit2 size={16}/></button>
          </PermissionGate>
        </div>
        <p><span className="font-medium text-Black capitalize">{t("coordinates")}: </span>{address}</p>
        <p><span className="font-medium text-Black">{t("openTime")}: </span>{openTime ? formatTime(openTime.slice(0,5)) : "—"}</p>
        <p><span className="font-medium text-Black">{t("closeTime")}: </span>{closeTime ? formatTime(closeTime.slice(0,5)) : "—"}</p>
        <p><span className="font-medium text-Black">{t("loginPhone")}: </span>{formatPhoneNumber(phoneLogin) || "—"}</p>
        <p>
          <span className="font-medium text-Black">{t("storeStatus")}: </span>
          <span className={`font-semibold ${isOnline ? "text-success" : "text-danger"}`}>
            {isOnline ? t("online") : t("offline")}
          </span>
        </p>
        <p><span className="font-medium text-Black">{t("createdAt")}: </span><DateTimeText date={createdAt}/></p>
        <p><span className="font-medium text-Black">{t("lastActive")}: </span><DateTimeText date={lastActive??""}/></p>
        <p><span className="font-medium capitalize text-Black">{t("lastLogin")}: </span><DateTimeText date={lastLoginAt??""}/></p>
        <div className="font-medium flex items-center gap-1">
          <span className=" text-Black">{t("taxNumber")}:</span> 
          <span className=" text-muted">{formatPhoneNumber(taxNumber) || "—"}</span>
          {taxNumberUrl && <button onClick={()=>setisOpentaxNumberUrl(p=>true)} className=" text-muted"><Image size={16}/></button>}
        </div>
        <div className="font-medium flex items-start gap-1">
          <span className=" text-Black">{t("commercialRegister")}: <span className=" text-muted">{formatPhoneNumber(commercialRegister) || "—"}</span>
</span> 
          {commercialRegisterUrl && <button onClick={()=>setisOpencommercialRegisterUrl(p=>true)} className=" text-muted"><Image size={16}/></button>}
        </div>
      </div>
       <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <ComissionForm
            defaultValues={{
            commission:commission?.commissionPercent??0
        }}
        id={store.id}
        onSubmitSuccess={() => {
            setIsOpen(p=>false);
  }}
        />
        </CustomModal>

         <CustomModal
        isOpen={isOpentaxNumberUrl}
        onClose={() => setisOpentaxNumberUrl(false)}
        title={taxNumber}
        >
        <div>
          <img src={taxNumberUrl??""} alt={taxNumber} />
        </div>
        </CustomModal>

        <CustomModal
        isOpen={isOpencommercialRegisterUrl}
        onClose={() => setisOpencommercialRegisterUrl(false)}
        title={commercialRegister}
        >
        <div>
          <img src={commercialRegisterUrl??""} alt={commercialRegister} />
        </div>
        </CustomModal>
    </div>
  );
};

export default StoreDetails;
